import type { ReactNode } from 'react';
import { T } from 'gt-react';

export function identifyPartySharedCopy(partyNoun: 'customer' | 'supplier'): {
  routingHelp: ReactNode;
  addRouteLabel: ReactNode;
  emptyRoutesHelp: ReactNode;
  othersHelp: ReactNode;
  othersNoMatchHelp: ReactNode;
  duplicateMessage: ReactNode;
  noEntitySelectedLabel: ReactNode;
} {
  if (partyNoun === 'customer') {
    return {
      routingHelp: (
        <T>
          Add a route per customer you want to handle separately. Each route
          becomes its own output socket on the node, and only the matching
          customer's socket fires.
        </T>
      ),
      addRouteLabel: <T>Add Customer Route</T>,
      emptyRoutesHelp: (
        <T>
          No routes yet. Without routes, the node still emits{' '}
          <code className="text-[10px]">top_pick</code>, but downstream steps
          will need to read the customer id from there directly.
        </T>
      ),
      othersHelp: (
        <T>
          Adds an extra output for matched customers that don't have a dedicated
          route above.
        </T>
      ),
      othersNoMatchHelp: (
        <T>
          If identification finds <strong>no</strong> surfaced customer:{' '}
          <strong>On</strong> emits <code className="text-[10px]">null</code> on{' '}
          <code className="text-[10px]">others</code> so your catch-all path
          still runs (e.g. manual review). <strong>Off</strong> (default) uses
          the skip sentinel so that branch does not run.
        </T>
      ),
      duplicateMessage: (
        <T>
          This customer is already routed by another row. Remove the duplicate.
        </T>
      ),
      noEntitySelectedLabel: <T>No customer selected</T>,
    };
  }

  return {
    routingHelp: (
      <T>
        Add a route per supplier you want to handle separately. Each route
        becomes its own output socket on the node, and only the matching
        supplier's socket fires.
      </T>
    ),
    addRouteLabel: <T>Add Supplier Route</T>,
    emptyRoutesHelp: (
      <T>
        No routes yet. Without routes, the node still emits{' '}
        <code className="text-[10px]">top_pick</code>, but downstream steps will
        need to read the supplier id from there directly.
      </T>
    ),
    othersHelp: (
      <T>
        Adds an extra output for matched suppliers that don't have a dedicated
        route above.
      </T>
    ),
    othersNoMatchHelp: (
      <T>
        If identification finds <strong>no</strong> surfaced supplier:{' '}
        <strong>On</strong> emits <code className="text-[10px]">null</code> on{' '}
        <code className="text-[10px]">others</code> so your catch-all path still
        runs (e.g. manual review). <strong>Off</strong> (default) uses the skip
        sentinel so that branch does not run.
      </T>
    ),
    duplicateMessage: (
      <T>
        This supplier is already routed by another row. Remove the duplicate.
      </T>
    ),
    noEntitySelectedLabel: <T>No supplier selected</T>,
  };
}
